import { Component, OnInit } from '@angular/core';
import {
  SkillWithRating,
  Katalog,
} from '../../../shared/model/katalog.model';
import { KatalogeService } from '../../../services/kataloge.service';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { MultilineTextEntryComponent } from '../../consultant/multiline-text-entry/multiline-text-entry.component';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-edit-catalogue',
  imports: [MultilineTextEntryComponent, RouterLink, MatButton, TranslatePipe],
  templateUrl: './edit-catalogue.component.html',
  styleUrl: './edit-catalogue.component.scss',
  standalone: true,
})
export class EditCatalogueComponent implements OnInit {
  katalog: Katalog;
  kentnisse: string[];
  id: string;
  editMode: boolean = false;
  formChanged = false;
  originalKatalog: Katalog;

  constructor(
    private katalogservice: KatalogeService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id');
    this.katalogservice.getByID(this.id).subscribe((value) => {
      this.katalog = value;
      this.originalKatalog = JSON.parse(JSON.stringify(value));
      this.createKenntnisse();
    });
  }

  createKenntnisse() {
    this.kentnisse = [];
    for (let kenntnis of this.katalog.kenntnisse) {
      this.kentnisse.push(kenntnis.bezeichnung);
    }
  }

  /**
   * NP20-889: Uebernimmt die bearbeitete Textliste und rettet dabei die uuids der bestehenden
   * Kenntnisse. Der Editor arbeitet auf reinem Text, die Bewertungen der Berater haengen seit
   * NP20-832 aber an der uuid des Katalog-Items. Ohne dieses Zuordnen bekaeme beim Speichern
   * jede Kenntnis eine neue uuid — und damit verloeren alle Berater alle Bewertungen dieses
   * Katalogs, schon beim blossen Ergaenzen eines Eintrags.
   *
   * Zugeordnet wird ueber den Text und gegen den urspruenglich geladenen Stand, damit die
   * Reihenfolge der Bearbeitungsschritte keine Rolle spielt. Eine umbenannte Kenntnis findet
   * bewusst keine Entsprechung und bekommt eine neue uuid: genau ihre Bewertung — und nur ihre —
   * setzt das Backend dann zurueck, so wie es NP20-832 vorsieht.
   */
  addKenntnisse(bezeichnungen: string[]) {
    const uuidsByBezeichnung = new Map<string, string[]>();
    for (const kenntnis of this.originalKatalog?.kenntnisse ?? []) {
      if (!kenntnis.uuid) continue;
      const key = (kenntnis.bezeichnung ?? '').trim();
      const bucket = uuidsByBezeichnung.get(key);
      if (bucket) {
        bucket.push(kenntnis.uuid);
      } else {
        uuidsByBezeichnung.set(key, [kenntnis.uuid]);
      }
    }

    this.katalog.kenntnisse = bezeichnungen.map(
      (bezeichnung) =>
        // shift(): Kenntnisse mit gleichem Text verbrauchen je eine uuid, statt sich dieselbe zu teilen.
        new SkillWithRating(
          bezeichnung,
          0,
          uuidsByBezeichnung.get(bezeichnung.trim())?.shift(),
        ),
    );
    this.checkFormChanged();
  }

  saveKatalogItem() {
    this.katalogservice.update(this.katalog).subscribe((response) => {
      // NP20-889: Den gespeicherten Stand uebernehmen. Fuer neu angelegte Kenntnisse vergibt erst
      // das Backend die uuid; ohne sie haette ein zweites Speichern sie wieder als neu behandelt.
      this.katalog = response.body ?? this.katalog;
      this.originalKatalog = JSON.parse(JSON.stringify(this.katalog));
      this.createKenntnisse();
      this.formChanged = false;
      this.editMode = false;
    });
  }

  checkFormChanged() {
    this.formChanged =
      JSON.stringify(this.katalog) !== JSON.stringify(this.originalKatalog);
  }
}
